import { useEffect, useState } from "react";
import FeedbackTab from "./FeedbackTab";
import SupportTab from "./SupportTab";
import { SubTabs } from "./AdminUI";

const TABS = [{ key: "feedback", label: "Feedback" }, { key: "support", label: "Support tickets" }];

export default function FeedbackSupportTab({ initialTab }) {
  const [tab, setTab] = useState(initialTab === "support" ? "support" : "feedback");
  useEffect(() => { if (initialTab) setTab(initialTab); }, [initialTab]);
  return (
    <div data-testid="admin-feedback-section">
      <SubTabs tabs={TABS} active={tab} onChange={setTab} testidPrefix="feedback-tab" />
      {tab === "feedback" ? <FeedbackTab /> : <SupportTab />}
    </div>
  );
}
